import { SiteProperties } from '../../../graphql/horizon-schema'

import { title as titleTransformer } from './title'

export interface ChoiceIcon {
  fill: string
  path: string
}

export interface Choice {
  key: string
  optionKey: string
  title: string
  colour?: string | null
}

export interface TransformedChoice {
  key: string
  optionKey: string
  title: string
  disabled: boolean
  selected: boolean
  icon?: ChoiceIcon | null
  image?: string | null
  colour?: string | null
  attribute?: boolean | null
  customLabel?: string | null
  useDisabledStyling: boolean
  displayText: string
}

export const getColourHexcode = (colour?: string | null) => {
  // @TODO: REBUILD-5103
  // Horrible workaround for short hex codes.
  // Validates they are 1-2 char hexes and pads them out
  if (colour && colour.startsWith('#') && colour.length < 7) {
    const hexStart = colour.substring(1, 3)
    const validateHex = '#'.padEnd(colour.length, hexStart)
    if (validateHex === colour) {
      return '#'.padEnd(7, hexStart)
    }
  }
  return colour
}

interface ChoiceProps {
  choice: Choice
  variant: {
    inStock: boolean
    images: { thumbnail?: string | null }[]
    notifyWhenInStockEnabled?: boolean | null
  }
  displayNotifyWhenInStock: boolean
  showOutOfStockAsDisabled?: boolean | null
  icon?: ChoiceIcon | null
  optionKeysToApplyAttribute?: string[]
  siteProperties: SiteProperties
  linkedOnOptionKey?: string | null
}

export const choiceTransformer = (props: ChoiceProps) => {
  const outOfStockNotification = props.displayNotifyWhenInStock
    ? props.variant.notifyWhenInStockEnabled && !props.variant.inStock
    : false
  const displayIcon = outOfStockNotification && props.icon

  const title = titleTransformer({
    siteProperties: props.siteProperties,
    outOfStockNotification: outOfStockNotification ?? false,
    inStock: props.variant.inStock,
    choiceTitle: props.choice.title,
  })

  const disabled = outOfStockNotification
    ? false
    : props.showOutOfStockAsDisabled
    ? !props.variant.inStock
    : false

  return {
    disabled:
      props.choice.optionKey === props.linkedOnOptionKey ? false : disabled,
    optionKey: props.choice.optionKey,
    title: props.choice.title,
    selected: false, // @TODO: REBUILD-8690: selected logic
    icon: displayIcon ? props.icon : null,
    key: props.choice.key,
    attribute: props.optionKeysToApplyAttribute?.includes(
      props.choice.optionKey,
    ),
    image: props.variant.images[0]?.thumbnail
      ? props.variant.images[0].thumbnail
      : null,
    colour: getColourHexcode(props.choice?.colour),
    useDisabledStyling: disabled ? true : false, // @TODO: REBUILD-8934 remove references to useDisabledStyling
    displayText: title,
  }
}
